import { StringParam, useQueryParam } from 'use-query-params';

const useBooleanQueryParam = (value) => {
	if (!value) return false;
	const [param] = useQueryParam(value, StringParam);
	return [param === 'true'];
};

export default useBooleanQueryParam;
